import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mlc-converter" }
const _hoisted_2 = { class: "mlc-converter section__container" }
const _hoisted_3 = { class: "section__content section__content--top" }
const _hoisted_4 = { class: "mlc-converter__selection" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mlc-converter__selection-item mlc-converter__selection-item--search" }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = { class: "mlc-converter__button-container" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "mlc-converter__loading-icon"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  id: "new-vt-code",
  class: "section section--primary section--edges"
}
const _hoisted_13 = { class: "section__container" }
const _hoisted_14 = { class: "section__content" }
const _hoisted_15 = { class: "mlc-converter__code-header" }
const _hoisted_16 = { class: "mlc-converter__code-container" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", { class: "mlc-converter__separator" }, null, -1)
const _hoisted_18 = { class: "mlc-converter__code" }
const _hoisted_19 = { class: "mlc-converter__code-label" }
const _hoisted_20 = { class: "teaser mlc-converter__teaser" }
const _hoisted_21 = {
  class: "mlc-converter__email",
  for: "email"
}
const _hoisted_22 = { class: "mlc-converter__button-container" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 1,
  class: "mlc-converter__email-success"
}
const _hoisted_25 = {
  key: 2,
  class: "mlc-converter__email-error"
}
const _hoisted_26 = {
  key: 3,
  class: "section__container"
}
const _hoisted_27 = { class: "section__content" }
const _hoisted_28 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_vit_dropdown = _resolveComponent("vit-dropdown")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.states.length)
            ? (_openBlock(), _createBlock(_component_vit_dropdown, {
                key: 0,
                label: (_ctx.selectedState && _ctx.selectedState.name) || _ctx.translations.state,
                inline: "",
                light: "",
                "dark-menu": "",
                rounded: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredStates, (state) => {
                    return (_openBlock(), _createBlock(_component_dropdown_item, {
                      key: 'filter-' + state.id,
                      onClick: ($event: any) => (_ctx.selectState(state.id))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["mlc-converter__selection-item", { 'mlc-converter__selection-item--active': _ctx.selectedState && (_ctx.selectedState.id === state.id) }])
                        }, _toDisplayString(state.name), 3)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["label"]))
            : (_ctx.statesError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.statesError), 1))
              : (_openBlock(), _createBlock(_component_loading_spinner, { key: 2 })),
          (!_ctx.currentVtCodesLoading)
            ? (_openBlock(), _createBlock(_component_vit_dropdown, {
                key: 3,
                label: (_ctx.selectedCurrentVtCode && _ctx.selectedCurrentVtCode.name) || _ctx.translations.currentVtCode,
                inline: "",
                light: "",
                "dark-menu": "",
                rounded: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_dropdown_item, { "prevent-close-dropdown": true }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_icon, {
                          name: "icn-search",
                          class: "icon"
                        }),
                        _createElementVNode("input", {
                          type: "text",
                          class: "mlc-converter__selection-search",
                          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSearchCurrentVtCodes && _ctx.onSearchCurrentVtCodes(...args)))
                        }, null, 32)
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.currentVtCodes.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filteredCurrentVtCodes, (currentVtCode) => {
                        return (_openBlock(), _createBlock(_component_dropdown_item, {
                          key: 'selection-' + currentVtCode.id,
                          onClick: ($event: any) => (_ctx.selectCurrentVtCode(currentVtCode.id))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["mlc-converter__selection-item", { 'mlc-converter__selection-item--active': _ctx.selectedCurrentVtCode && (_ctx.selectedCurrentVtCode.id === currentVtCode.id) }])
                            }, _toDisplayString(currentVtCode.name), 3)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]))
            : (_openBlock(), _createBlock(_component_loading_spinner, { key: 4 })),
          (_ctx.currentVtCodesError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.currentVtCodesError), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "button mlc-converter__button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchNewVtCode && _ctx.fetchNewVtCode(...args))),
            disabled: !_ctx.selectedState || !_ctx.selectedCurrentVtCode
          }, _toDisplayString(_ctx.translations.fetchCodeButtonLabel), 9, _hoisted_9)
        ])
      ])
    ]),
    (_ctx.loadingNewVtCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_loading_spinner)
        ]))
      : _createCommentVNode("", true),
    (_ctx.newVtCodeError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.newVtCodeError), 1))
      : _createCommentVNode("", true),
    (_ctx.newVtCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.translations.yourNewCodeHeader), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createElementVNode("h2", _hoisted_18, _toDisplayString(_ctx.newVtCode.newVtCode), 1),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.translations.yourNewCode), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.translations.receiveByEmail), 1),
                  (!_ctx.emailSuccess)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translations.emailAddress), 1),
                        _createElementVNode("input", {
                          type: "text",
                          id: "email",
                          placeholder: "john.doe@mail.com",
                          class: "form__input",
                          ref: "email",
                          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onEmailChanged()))
                        }, null, 544),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("button", {
                            class: "button mlc-converter__button",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args))),
                            disabled: _ctx.emailValue === '' || _ctx.sendingEmail
                          }, _toDisplayString(_ctx.translations.sendCode), 9, _hoisted_23)
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.emailSuccess), 1)),
                  (_ctx.emailError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.emailError), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.newVtCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.translations.additionalInformation), 1),
            _createElementVNode("table", _hoisted_28, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.translations.description), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$formatNumber(_ctx.newVtCode.description)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.translations.permitRequired), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.newVtCode.permitRequired ? _ctx.translations.yes : _ctx.translations.no), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.translations.accreditationRequired), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.newVtCode.accreditationRequired ? _ctx.translations.yes : _ctx.translations.no), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.translations.maxWeight), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$formatNumber(_ctx.newVtCode.maxWeight)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.translations.permitMinWeight), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$formatNumber(_ctx.newVtCode.permitMinWeight)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.translations.permitMaxWeight), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$formatNumber(_ctx.newVtCode.permitMaxWeight)), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}